/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStockorderEditCtrl
 */
angular.module('mercury.modules.stock.stockorder')
.controller('StockStockorderEditCtrl', ["dialog", "$filter", "ngToast", "$q", "$scope", "$state", "$stateParams", "StockSuppliers", "StockItems", "StockOrderTemplates", "StockPurchaseOrders", "StockUnits", "StockBrands", "$timeout", "title", "userinfo", "StockCost", function(dialog, $filter, ngToast, $q, $scope, $state, $stateParams,
  StockSuppliers, StockItems, StockOrderTemplates, StockPurchaseOrders, StockUnits, StockBrands, $timeout, title, 
  userinfo, StockCost) {

  $scope.order = {
    orderedby: userinfo.userDetails().name,
    notes: '',
    creditRequest: ($stateParams.creditRequest == 'true') ? true : false,
    lines: [],
    valid: true
  };

  title.set($scope.order.creditRequest ? 'Credit Request' : 'Edit Order');

  $scope.items = StockItems.getAllStockApi();
  $scope.suppliers = StockSuppliers.getAll();
  $scope.brands = StockBrands.getAllActive();
  $scope.allUnits = StockUnits.getAllStockApi(true);

  if ($stateParams.templateId) {
    $scope.template = StockOrderTemplates.get($stateParams.templateId);
  } else {
    $scope.template = {
      name: '',
      creditRequest: $scope.order.creditRequest,
      lines: []
    };
  }

  $scope.loadingPromises = [
    $scope.items.$promise,
    $scope.suppliers.$promise,
    $scope.allUnits.$promise,
    $scope.brands.$promise,
    $scope.template.$promise
  ];

  $q.all($scope.loadingPromises)
  .then(function() {

    $scope.units = $scope.allUnits.filter(u => u.datestampDeleted === null);
    
    angular.forEach($scope.template.lines, function(line) {
      delete line.id;
      $scope.order.lines.push(line);
    });
  
    if ($stateParams.importFromLocalStorage === 'true') {
      try {
        var importObj = JSON.parse(localStorage.getItem('stockOrderLinesToImport'));
        if (importObj && Array.isArray(importObj.lines)) {

          // Wait for all items to be loaded before adding lines
          $timeout(function() {
            importObj.lines.forEach(function(line, idx) {
              var item = $scope.items.find(i => i.id === line.stockItemId);
              if (item) {
                $scope.addLine(item, false);

                var addedLine = $scope.order.lines.find(l => l.stockItemId === item.id)

                // Adjust the imported quantity to match the base unit expected by the model.
                // The inputnumber directive expect quantity in the base unit    
                if (addedLine && line.quantity && addedLine.unitRatio) {
                  addedLine.quantity = line.quantity * addedLine.unitRatio;
                }

                addedLine.unitCost = line.unitCost;

              } else {
                console.error(`[StockOrder] No matching item found for line ${idx}:`, line);
              }
            });
            // Clear after import to avoid duplicates
            localStorage.removeItem('stockOrderLinesToImport'); 
          }, 0);
        } else {
          console.error('[StockOrder] No valid lines array in import object');
        }
      } catch (e) {
        console.error('[StockOrder] Error parsing stockOrderLinesToImport:', e);
      }
    }  
  
  }, function() {
    $state.go('Stock.PurchaseorderActive');
  });

  /**
   * Add up the total cost of all order lines.
   */
  $scope.totalCost = function() {
    var totalCost = 0;
    angular.forEach($scope.order.lines, function(orderLine) {
      totalCost += (orderLine.quantity * orderLine.unitCost);
    });

    $scope.order.total = totalCost;

    return totalCost;
  };

  $scope.itemOptions = function() {
    var existingItems = {};
    angular.forEach($scope.order.lines, function(line) {
      existingItems[line.stockItemId] = true;
    });

    var avaliableItems = [];
    angular.forEach($scope.items, function(item) {
      if (!existingItems[item.id]) {
        avaliableItems.push(item);
      }
    });
    return avaliableItems;
  };

  var validateStockCode = function(line) {
    if (line.supplierValidateStockCode !== true) {
      return;
    }

    StockItems.searchStockcodes(line.stockCode, line.supplierId)
    .$promise.then(function(supplierItems) {
      var isValid = false;
      angular.forEach(supplierItems, function(supplierItem) {
        if (supplierItem.itemCode == line.stockCode) {
          isValid = true;
        }
      });

      line.valid = isValid;
      $scope.order.valid = $filter('filter')($scope.order.lines, {valid: false}).length === 0;
    });
  };

  /**
   * Fetch the stockcode and cost for a line from the server. Then
   * validate that stock code if required
   */
  var getStockCode = function(line, ignoreUnitCost) {
    StockItems.getItemSupplier(
      line.stockItemId,
      line.unitId,
      line.supplierId,
      line.brandId
    ).then(function(result) {
      if (result) {
        line.stockCode = result.stockCode;
        if (!ignoreUnitCost) {
          line.unitCost = result.unitCost;
        }
      } else {
        line.stockCode = '';
      }

      validateStockCode(line);
    });
  };

  /**
   * Add a new item line to the order.
   */
  $scope.addLine = function(item, shouldGetCost) {
    if (typeof shouldGetCost === 'undefined') shouldGetCost = true;
    // Putting the stock cost request first so it returns ASAP
    var stockCostPromise = shouldGetCost
      ? StockCost.get([`${item.id},${moment().format()}`])
      : $q.when();

     // Items Created via the moreItems dialog are created via WebAPI and thus will have no variants hence the '?'. 
     // This can be removed when we update this workfow.
     var defaultVariant = !item.suppliers
      ? undefined 
      : item.suppliers.find(variant => variant.supplierId === item.defaultSupplierId && variant.defaultForSupplier);
     var defaultSupplier = $scope.suppliers.find(s => s.id === item.defaultSupplierId);
 
     var baseOrderLine = {
       purchaseOrderId: $scope.order.id,
       quantityOrdered: 0,
       unitCostOrdered: 0,
       unitCost: 0,
       supplierId: item.defaultSupplierId,
       supplierName: defaultSupplier ? defaultSupplier.name : undefined,
       supplierValidateStockCode: defaultSupplier ? defaultSupplier.validateStockCode : undefined,
       stockItemId: item.id,
       stockItemName: item.name,
       valid: true,
       costPromise: stockCostPromise
     }
 
     // If there is a default variant for this supplier then we use that otherwise just use 
     // the parent item's values
     if (defaultVariant) {
       var variantUnit = $scope.allUnits.find(u => u.id === defaultVariant.unitId);
       var variantBrand = $scope.brands.find(b => b.id === defaultVariant.brandId);
 
       $scope.order.lines.push(
         Object.assign(
           baseOrderLine, 
           {
             stockCode: defaultVariant.stockCode || '',
             quantity: 1 * variantUnit.ratio,
             brandId: variantBrand ? variantBrand.id : undefined,
             brandName: variantBrand ? variantBrand.name : undefined,
             unitName: variantUnit.name,
             unitId: variantUnit.id,
             unitRatio: variantUnit.ratio,
           }
         )
       );
     } else {
      var orderingUnit = $scope.allUnits.find(u => u.id === item.orderingUnitId);
      var defaultBrand = $scope.brands.find(b => b.id === item.defaultBrandId);
 
       $scope.order.lines.push(
         Object.assign(
           baseOrderLine,
           {
             stockCode: 'Loading...',
             quantity: 1 * orderingUnit.ratio,
             brandId: item.defaultBrandId,
             brandName: defaultBrand ? defaultBrand.name : undefined,
             unitName: item.orderingUnitName,
             unitId: item.orderingUnitId,
             unitRatio: orderingUnit.ratio,
           }
         )
       );
       getStockCode($scope.order.lines[$scope.order.lines.length - 1], ignoreUnitCost = true);
     }
 
     // Update the unitCost of the line to be what cost of what the StockCost request returns.
     // As this is within a single call of the addItem we know `$scope.order.lines.length - 1` 
     // as the index refers to the correct line.
     if (shouldGetCost) {
      $scope.order.lines[$scope.order.lines.length - 1].costPromise
        .then(stockCost => {
          $scope.order.lines[$scope.order.lines.length - 1].unitCost = stockCost.itemCosts[item.id][0].cost
        })
     }

    $scope.stockOrderForm.itemToAdd.$setValidity('haslines', true);

    validateStockCode($scope.order.lines[$scope.order.lines.length - 1])
  };

  $scope.brandUpdated = function(line) {
    getStockCode(line);

    angular.forEach($scope.items, function(item, index) {
      if (item.id == line.stockItemId && line.brandId != item.defaultBrandId) {
        var confirmMsg = 'The brand you have selected is not the default for this item. ' +
          'Would you like to use this brand as the default in the future?';

        dialog.confirm(confirmMsg)
        .then(function(confirmed) {
          if (confirmed) {
            StockItems.patch(line.stockItemId, 'DefaultBrandId', line.brandId)
            .then(function() {
              $scope.items[index].defaultBrandId = line.brandId;
              $scope.items[index].defaultBrandName = line.brandName;
            });
          }
        });
      }
    });
  };

  $scope.supplierUpdated = function(line, newSupplier) {
    line.supplierValidateStockCode = newSupplier.validateStockCode;

    getStockCode(line);

    angular.forEach($scope.items, function(item, index) {
      if (item.id == line.stockItemId && line.supplierId != item.defaultSupplierId) {
        var confirmMsg = 'The supplier you have selected is not the default for this item. ' +
        'Would you like to use this supplier as the default in the future?';

        dialog.confirm(confirmMsg)
        .then(function(confirmed) {
          if (confirmed) {
            StockItems.patch(line.stockItemId, 'DefaultSupplierId', line.supplierId)
            .then(function() {
              $scope.items[index].defaultSupplierId = line.supplierId;
              $scope.items[index].defaultSupplierName = line.supplierName;
            });
          }
        });
      }
    });
  };

  $scope.unitUpdated = function(line, newUnit) {
    line.quantity = (line.quantity / line.unitRatio) * newUnit.ratio;
    line.unitCost = (line.unitCost * line.unitRatio) / newUnit.ratio;
    line.unitRatio = newUnit.ratio;

    getStockCode(line);

    angular.forEach($scope.items, function(item, index) {
      if (item.id == line.stockItemId && line.unitId != item.orderingUnitId) {
        var confirmMsg = 'The ordering unit you have selected is not the default for this item. ' +
        'Would you like to use this unit as the default in the future?';

        dialog.confirm(confirmMsg)
        .then(function(confirmed) {
          if (confirmed) {
            StockItems.patch(line.stockItemId, 'OrderingUnitId', line.unitId)
            .then(function() {
              $scope.items[index].orderingUnitId = line.unitId;
              $scope.items[index].orderingUnitName = line.unitName;
            });
          }
        });
      }
    });
  };

  /**
   * Remove a line from the order.
   */
  $scope.removeLine = function(index) {
    $scope.order.lines.splice(index, 1);
    $scope.stockOrderForm.itemToAdd.$setValidity('haslines', $scope.order.lines.length > 0);
  };

  /**
   * Validate the order then call to the server to generate the purchase orders
   */
  $scope.generatePurchaseOrder = function() {
    $scope.stockOrderForm.$setSubmitted();
    $scope.stockOrderForm.itemToAdd.$setValidity('haslines', $scope.order.lines.length > 0);

    if ($scope.stockOrderForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors on this order.');
      return;
    }

    $scope.generatingOrder = StockPurchaseOrders.generate($scope.order);
    $scope.generatingOrder.then(function() {
      $state.go('Stock.PurchaseorderActive');
    });
  };

  /**
 * Open the dialog to save the current order as a template.
 */
  $scope.openTemplateSaveDialog = function() {
    $scope.stockOrderForm.$setSubmitted();
    $scope.stockOrderForm.itemToAdd.$setValidity('haslines', $scope.order.lines.length > 0);

    if ($scope.stockOrderForm.$invalid) {
      ngToast.dismiss();
      ngToast.danger('Please fix the errors on this order.');
      return;
    }

    dialog.open({
      templateUrl: 'modules/stock/stockorder/saveastemplate.tpl.html',
      scope: $scope
    });
  };

  $scope.saveTemplateComplete = function(updateExisting, formCtrl) {
    formCtrl.$setSubmitted();
    if (formCtrl.$valid) {
      $scope.template.lines = [];

      var lineOrder = 1;
      angular.forEach($scope.order.lines, function(orderLine) {
        $scope.template.lines.push({
          stockItemId: orderLine.stockItemId,
          supplierId: orderLine.supplierId,
          brandId: orderLine.brandId,
          unitId: orderLine.unitId,
          quantity: orderLine.quantity,
          unitCost: orderLine.unitCost,
          stockCode: orderLine.stockCode,
          lineOrder: lineOrder++
        });
      });

      if (updateExisting && $scope.template.id) {
        StockOrderTemplates.update($scope.template)
        .then(function() {
          ngToast.success('Order Template Updated.');
          dialog.close();
        });
      } else {
        StockOrderTemplates.save($scope.template)
        .then(function(newTemplate) {
          $scope.template.id = newTemplate.id;

          ngToast.success('Order Template Updated.');
          dialog.close();
        });
      }
    }
  };

  $scope.unitsMore = function(line) {
    dialog.open({
      controller: 'StockUnitPopupCtrl',
      templateUrl: 'modules/stock/unit/popup.tpl.html',
      resolve: {
        onAdd: function() {
          return function(newUnit) {
            $scope.units.push(newUnit);
          };
        }
      }
    }).then(function(result) {
      line.unitId = result.id;
      line.unitName = result.name;

      $scope.unitUpdated(line, result);
    });
  };

  $scope.brandsMore = function(line) {
    dialog.open({
      controller: 'StockBrandPopupCtrl',
      templateUrl: 'modules/stock/brand/popup.tpl.html',
      resolve: {
        onAdd: function() {
          return function(newBrand) {
            $scope.brands.push(newBrand);
          };
        }
      }
    }).then(function(result) {
      line.brandId = result.id;
      line.brandName = result.name;

      $scope.brandUpdated(line);
    });
  };

  $scope.suppliersMore = function(line) {
    dialog.open({
      controller: 'StockSupplierPopupCtrl',
      templateUrl: 'modules/stock/supplier/popup.tpl.html',
      size: 'lg',
      resolve: {
        onAdd: function() {
          return function(newSupplier) {
            $scope.suppliers.push(newSupplier);
          };
        }
      }
    }).then(function(result) {
      line.supplierId = result.id;
      line.supplierName = result.name;

      $scope.supplierUpdated(line);
    });
  };

  $scope.itemsMore = function() {
    dialog.open({
      controller: 'StockItemPopupCtrl',
      templateUrl: 'modules/stock/item/popup.tpl.html',
      size: 'lg',
      resolve: {
        existingItems: function() {
          var result = [];
          angular.forEach($scope.order.lines, function(line) {
            result.push(line.stockItemId);
          });
          return result;
        },
        onItemAdd: function() {
          return function(newItem) {
            $scope.items.push(newItem);
          };
        },
        onBrandAdd: function() {
          return function(newBrand) {
            $scope.brands.push(newBrand);
          };
        },
        onSupplierAdd: function() {
          return function(newSupplier) {
            $scope.suppliers.push(newSupplier);
          };
        }
      }
    }).then(function(result) {
      $scope.addLine(result);
    });
  };

  $scope.stockcodeMore = function(line) {
    dialog.open({
      controller: 'StockPurchaseorderPopupstockcodesCtrl',
      templateUrl: 'modules/stock/purchaseorder/popupstockcodes.tpl.html',
      size: 'lg',
      resolve: {
        stockSupplierId: function() {
          return line.supplierId;
        }
      }
    }).then(function(result) {
      line.stockCode = result.itemCode;
      $scope.stockcodeSelected(line);
    });
  };

  $scope.searchStockCodes = function(searchStr, line) {
    line.stockCode = searchStr;

    return StockItems.searchStockcodes(searchStr, line.supplierId).$promise;
  };

  $scope.stockcodeSelected = function(line) {
    line.valid = true;
    $scope.order.valid = $filter('filter')($scope.order.lines, {valid: false}).length === 0;
  };

  $scope.stockcodeLine = function(item) {
    return '<div style="display: inline-block; width: 85px">' + item.value.itemCode + '</div>' +
      '<div style="display: inline-block; width: 200px">' + item.value.name + '</div>' +
      '<div style="display: inline-block; width: 70px">' + (item.value.unit || 'Not Set') + '</div>' +
      '<div style="display: inline-block; width: 70px">' + (item.value.brand || 'Not Set') + '</div>';
  };

  $scope.stockcodeHeader = function() {
    return '<li class="ui-autocomplete-category"><div style="display: inline-block; width: 85px">Code</div>' +
      '<div style="display: inline-block; width: 200px">Description</div>' +
      '<div style="display: inline-block; width: 70px">Unit</div>' +
      '<div style="display: inline-block; width: 70px">Brand</div></li>';
  };

  $scope.isPromisePending = function(promise) {
    return promise && promise.$$state.status == 0;
  }

  $scope.allLinePromisesResolved = function() {
    var lines = $scope.order.lines;
    return lines && lines.every(l => !$scope.isPromisePending(l.costPromise))
  }
}]);
